module.exports = "<p>\n  referral works!\n</p>\n"